import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the PeriodicityFormatterProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class PeriodicityFormatterProvider {

  constructor() {
    console.log('Hello PeriodicityFormatterProvider Provider');
  }

    getPeriod() {
        return [{"name": "jeden Tag", "value": {"days":1}},
                {"name": "jede Woche", "value": {"days":7}},
                {"name": "alle zwei Wochen", "value": {"days":14}},
                {"name": "jeden Monat", "value": {"months":1}},
                {"name": "alle zwei Monate", "value": {"months":2}},
                {"name": "vierteljährlich", "value": {"months": 3}},
                {"name": "halbjährlich", "value": {"months":6}},
                {"name": "jährlich", "value": {"years":1}}
            ]
    }

    format(val) {
        let relevant_obj = this.getPeriod().filter(function(item){return JSON.stringify(item.value) === JSON.stringify(val.execution_period) })

        if(relevant_obj.length > 0){
            return relevant_obj[0].name
        }

        return "UK"
    }

}



// WEBPACK FOOTER //
// ./src/providers/periodicity-formatter/periodicity-formatter.ts